// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Tab {
    static getAttributeTypeMap() {
        return Tab.attributeTypeMap;
    }
}
Tab.discriminator = undefined;
Tab.additionalProperties = false;
Tab.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "anchorString",
        "baseName": "anchorString",
        "type": "string"
    },
    {
        "name": "anchorUnits",
        "baseName": "anchorUnits",
        "type": "string"
    },
    {
        "name": "anchorXOffset",
        "baseName": "anchorXOffset",
        "type": "string"
    },
    {
        "name": "anchorYOffset",
        "baseName": "anchorYOffset",
        "type": "string"
    },
    {
        "name": "width",
        "baseName": "width",
        "type": "string"
    },
    {
        "name": "height",
        "baseName": "height",
        "type": "string"
    },
    {
        "name": "pageNumber",
        "baseName": "pageNumber",
        "type": "string"
    },
    {
        "name": "xPosition",
        "baseName": "xPosition",
        "type": "string"
    },
    {
        "name": "yPosition",
        "baseName": "yPosition",
        "type": "string"
    },
    {
        "name": "required",
        "baseName": "required",
        "type": "boolean"
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string"
    },
];
//# sourceMappingURL=tab.js.map